export default __webpack_public_path__ + "static/media/newsuccess.5b3b6214.png";